import React from 'react';

// The colour logo is rendered as TWO separate SVGs so we can independently
// animate the skull mark (subtle "nod" on page load — see App.css).
// Both files are generated from /app/frontend/public/logo.svg via
// /tmp/split_logo.py. The single-file /logo.svg is still available for any
// non-header usage (FloatingWhatsApp badge, WhatsApp share image, etc).
const SKULL_SRC = "/logo-skull.svg";
const WORDMARK_SRC = "/logo-wordmark.svg";
// Locally-served, pre-processed white-on-transparent PNG (see
// /app/backend/scripts/build_white_logo.py). Rebuild that script if the
// brand JPG ever changes.
const WHITE_LOGO = "/logo-white.png";

const Logo = ({ className = "", variant = "color" }) => {
  if (variant === "white") {
    return (
      <img
        src={WHITE_LOGO}
        alt="The TMD Physio - Krina Panchal"
        className={`logo-image ${className}`}
        draggable={false}
      />
    );
  }

  return (
    <span
      className={`logo-image logo-image-svg ${className}`}
      aria-label="The TMD Physio - Krina Panchal"
      role="img"
    >
      <img
        src={SKULL_SRC}
        alt=""
        className="logo-image-skull"
        draggable={false}
      />
      <img
        src={WORDMARK_SRC}
        alt=""
        className="logo-image-wordmark"
        draggable={false}
      />
    </span>
  );
};

export default Logo;
